import React, { useState } from "react";
import Breadcrumb from "../../../../core/common/Breadcrumb/breadcrumb";
import { Link } from "react-router-dom";
import ProfileCard from "../../common/profileCard";
import StudentSidebar from "../../common/studentSidebar";
import SettingsLinks from "../settingsLinks/settingsLinks";
import SettingsModal from "../settingsModal/settingsModal";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { User } from "../../../../core/types/types";
import { updateUser } from "../../../../core/redux/authSlice";
import CustomSelect from "../../../../core/common/commonSelect";
import { Country } from "../../../../core/common/selectOption/json/selectOption";
import apiInstance from "../../../../utility/apiInstance";

const StudentVisa = () => {

    const user = useSelector((state: any) => state.auth.user);
    const dispatch = useDispatch();
    
    const [msg, setMsg] = useState({
        error: false,
        loading: false,
        text: ''
    });

    const [formData, setFormData] = useState<User>({
        id: user?.id || "",
        visa: {
            visaRefused: user?.visa?.visaRefused || "no",
            availableVisa: {
                canadian: user?.visa?.availableVisa?.canadian || false,
                usa: user?.visa?.availableVisa?.usa || false,
                australian: user?.visa?.availableVisa?.australian || false,
                uk: user?.visa?.availableVisa?.uk || false,
                irish: user?.visa?.availableVisa?.irish || false,
                noVisa: user?.visa?.availableVisa?.noVisa || true,
            },
            moreInfo: user?.visa?.moreInfo || "",
        },
    });

    const handleInputChange = (e: { target: { name: string; value: string | number } }) => {
        const { name, value } = e.target;

        setFormData((prevState) => ({
            ...prevState,
            visa: {
                ...(prevState.visa ?? {
                    visaRefused: 'no',
                    availableVisa: {
                        canadian: false,
                        usa: false,
                        australian: false,
                        uk: false,
                        irish: false,
                        noVisa: true
                    },
                    moreInfo: ''
                }),
                [name]: value,
            }
        }));
    };

    const handleCheckboxChange = (e: any) => {
        const { name, checked } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            visa: {
                ...(prevState.visa ?? {
                    visaRefused: 'no',
                    availableVisa: {
                        canadian: false,
                        usa: false,
                        australian: false,
                        uk: false,
                        irish: false,
                        noVisa: true
                    },
                    moreInfo: ''
                }),
                availableVisa: {
                    ...(prevState.visa?.availableVisa ?? {
                        canadian: false,
                        usa: false,
                        australian: false,
                        uk: false,
                        irish: false,
                        noVisa: true
                    }),
                    [name]: checked
                }
            }
        }));
    } 

    const updateProfile = async (e: React.FormEvent) => {
        e.preventDefault();

        setMsg({
            error: false,
            loading: true,
            text: ''
        });

        try {
            const response = await apiInstance.patch(`/api/users/${formData.id}`, formData)
            dispatch(updateUser(response.data.doc))
            setMsg({
                error: false,
                loading: false,
                text: 'Details updated successfully!'
            });

        } catch (error: any) {
            setMsg({
                error: true,
                loading: false,
                text: error.message
            });
        }
    }

    return (
        <>
            <div className="content">
                <div className="container">
                    {/* P[name]: valurofile */}
                    <ProfileCard />
                    {/* /Profile */}
                    <div className="row">
                        {/* Sidebar */}
                        <StudentSidebar />
                        {/* Sidebar */}
                        <div className="col-lg-9">
                            <div className="mb-3">
                                <h5>Settings</h5>
                            </div>
                            <SettingsLinks />
                            <div className="card">
                                <div className="card-body">
                                    <form onSubmit={updateProfile}>
                                        <div>
                                            <div className="edit-profile-info mb-3">
                                                <h5 className="mb-1">VISA & Study Permit</h5>
                                                <p>Edit your details</p>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="mb-3">
                                                        <label className="custom_check col-12">
                                                            <input
                                                                type="checkbox"
                                                                name="canadian"
                                                                checked={formData.visa?.availableVisa.canadian}
                                                                onChange={handleCheckboxChange}
                                                            />
                                                            <span className="checkmark" /> Canadian Study Permit / Visitor Visa
                                                        </label>
                                                        <label className="custom_check col-12">
                                                            <input
                                                                type="checkbox"
                                                                name="usa"
                                                                checked={formData.visa?.availableVisa.usa}
                                                                onChange={handleCheckboxChange}
                                                            />
                                                            <span className="checkmark" /> USA F1 Visa
                                                        </label>
                                                        <label className="custom_check col-12">
                                                            <input
                                                                type="checkbox"
                                                                name="australian"
                                                                checked={formData.visa?.availableVisa.australian}
                                                                onChange={handleCheckboxChange}
                                                            />
                                                            <span className="checkmark" /> Australian Study Visa
                                                        </label>
                                                        <label className="custom_check col-12">
                                                            <input
                                                                type="checkbox"
                                                                name="uk"
                                                                checked={formData.visa?.availableVisa.uk}
                                                                onChange={handleCheckboxChange}
                                                            />
                                                            <span className="checkmark" /> UK Tier 4 Student / Short Term Study Visa
                                                        </label>
                                                        <label className="custom_check col-12">
                                                            <input
                                                                type="checkbox"
                                                                name="irish"
                                                                checked={formData.visa?.availableVisa.irish}
                                                                onChange={handleCheckboxChange}
                                                            />
                                                            <span className="checkmark" /> Irish Stamp 2
                                                        </label>
                                                        <label className="custom_check col-12">
                                                            <input
                                                                type="checkbox"
                                                                name="noVisa"
                                                                checked={formData.visa?.availableVisa.noVisa}
                                                                onChange={handleCheckboxChange}
                                                            />
                                                            <span className="checkmark" /> I don't have this
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Have you been refused a visa from Canada, the USA, the United Kingdom, New Zealand, Australia or Ireland? <span className="text-danger"> *</span>
                                                        </label>
                                                        <CustomSelect
                                                            options={[
                                                                { label: 'Yes', value: 'yes' },
                                                                { label: 'No', value: 'no' },
                                                            ]}
                                                            className="select d-flex"
                                                            placeholder="Select"
                                                            name="visaRefused"
                                                            value={formData.visa?.visaRefused}
                                                            onChange={(selectedOption) => {
                                                                handleInputChange({
                                                                    target: {
                                                                        name: 'visaRefused',
                                                                        value: selectedOption.value
                                                                    }
                                                                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Please provide more information about your current study permit/visa and any past refusals, if any
                                                        </label>
                                                        <textarea
                                                            rows={4}
                                                            className="form-control"
                                                            defaultValue=""
                                                            name="moreInfo"
                                                            value={formData.visa?.moreInfo}
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <button
                                                        className="btn btn-secondary rounded-pill"
                                                        type="submit"
                                                    >
                                                        Save
                                                    </button>
                                                    {msg.loading &&
                                                        <span className="mt-3 fs-14 fw-normal d-flex align-items-center justify-content-center">Updating details...</span>
                                                    }
                                                    {!msg.loading &&
                                                        <span className={`mt-3 ${msg.error ? 'text-red' : ''} fs-14 fw-normal d-flex align-items-center justify-content-center`}>{msg.text}</span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SettingsModal />
        </>
    );
};

export default StudentVisa;
